import {
    DTOCardFormField,
} from 'app/types/form.types'

import {
    LaneStatus,
} from 'app/enums/label.enums'
import {
    AccountLaneForm,
} from '../AccountLanes.types'
import {
    AccountLaneFormFieldsArgs,
} from '../AccountLaneForm/AccountLaneForm'

export default ({
    getAllowedValues,
    laneLeadPermission,
    requiredBillingCompany,
}: Partial<AccountLaneFormFieldsArgs>): DTOCardFormField <AccountLaneForm>[] => {
    return [{
        id: 'general',
        title: 'General',
        fields: [
            {
                id: 'column1',
                fields: [
                    {
                        name: 'laneNumber',
                        componentName: 'InputSingleline',
                        labelKey: 'AccountLane.laneNumber',
                        disabled: true,
                    },
                    {
                        name: 'customerSite',
                        componentName: 'LocationObjectSelector',
                        labelKey: 'LaneUpdateNewDto.customerSite',
                    },
                    {
                        name: 'billingCompany',
                        componentName: 'BillingCompanyObjectSelector',
                        labelKey: 'LaneUpdateNewDto.billingCompany',
                        required: requiredBillingCompany,
                    },
                    {
                        name: 'laneLead',
                        componentName: 'UserObjectSelector',
                        labelKey: 'AccountLane.laneLead',
                        required: true,
                        disabled: !laneLeadPermission,
                    },
                    {
                        name: 'laneSupporter',
                        componentName: 'UserObjectSelector',
                        labelKey: 'AccountLane.laneSupporter',
                        disabled: !laneLeadPermission,
                    },
                ],
            },
            {
                id: 'column2',
                fields: [
                    {
                        name: 'laneStatus',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(LaneStatus),
                        labelKey: 'LaneQuoteRequest.selectedLaneStatus',
                        disabled: true,
                    },
                    {
                        name: 'expPalletsYear',
                        required: true,
                        componentName: 'InputSingleline',
                        labelKey: 'LaneBasicView.expPalletsYear',
                    },
                    {
                        name: 'laneComment',
                        componentName: 'LongText',
                        labelKey: 'AccountLane.laneComment',
                    },
                    {
                        name: 'createdOn',
                        componentName: 'DateTimeSelect',
                        disabled: true,
                        labelKey: 'Accounts.createdOn',
                    },
                    {
                        name: 'createdBy',
                        componentName: 'InputSingleline',
                        disabled: true,
                        labelKey: 'Accounts.createdBy',
                    },
                ],
            },
        ],
    }]
}
